const ROLES = {
  "Super Admin": 1,
  Admin: 2,
  Customer: 3,
};

module.exports = ROLES;
